import {observable} from "mobx";
import api from "../../Services/Api";

class PinCodeFormStore {
    @observable pinCode: string = '';
    @observable acceptedPinCode: string = '';
    @observable visible: boolean = false;
    
    setPinCode(value: string) {
        this.pinCode = value;
    }
    
    show() {
        this.visible = true;
    }
    
    hide() {
        this.visible = false;
        this.pinCode = '';
    }
    
    accept() {
        this.acceptedPinCode = this.pinCode;
        this.hide();
        void this.save();
    }
    
    async save() {
        if (!this.acceptedPinCode) {
            return;
        }
        
        const result = await api.post('employee/savePinCode', {
            pinCode: this.acceptedPinCode
        });
    }
}

const pinCodeFormStore = new PinCodeFormStore();
export default pinCodeFormStore;